import React from 'react';

interface WithdrawConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  jobTitle?: string;
  loading?: boolean;
}

const WithdrawConfirmationModal: React.FC<WithdrawConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  jobTitle,
  loading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Withdraw Application?</h2>
          <p className="text-gray-600 mb-2">
            This action will remove your application from the hiring process.
          </p>
          {jobTitle && (
            <p className="text-gray-700 mb-4">
              You're withdrawing from: <span className="font-medium">{jobTitle}</span>
            </p>
          )}
          <p className="text-gray-600 mb-6">You can't undo this.</p>
          
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onConfirm}
              disabled={loading}
              className={`px-6 py-2 rounded-lg font-medium transition-colors flex-1 ${
                loading 
                  ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                  : 'bg-red-600 text-white hover:bg-red-700'
              }`}
            >
              {loading ? 'Withdrawing...' : 'Yes, Withdraw'}
            </button>
            <button
              onClick={onClose}
              disabled={loading}
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium flex-1 disabled:opacity-50"
            >
              No, Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawConfirmationModal;